import { useRef, useState } from "react";

import { INPUT_FOCUSED } from "../../AutocompleteTextInput";

import customFetch from "pstat-anywhere/utils/customFetch";

export default function useUserAndUserGroupAutocomplete({ users, groups }) {
  const [suggestions, setSuggestions] = useState([]);
  const userSuggestionCache = useRef({});
  const groupSuggestionCache = useRef({});

  function fetchSuggestions({ value, reason }) {
    let valueToFetch = value;
    if (reason === INPUT_FOCUSED) {
      valueToFetch = "";
    }
    const userSuggestions = fetchUsersSuggestions(valueToFetch);
    const groupSuggestions = fetchGroupSuggestions(valueToFetch);
    return Promise.all([userSuggestions, groupSuggestions]).then(
      suggestions => {
        const [userSuggestions, groupSuggestions] = suggestions;
        updateSuggestions(userSuggestions, groupSuggestions);
        return suggestions;
      }
    );
  }

  async function fetchGroupSuggestions(value) {
    if (!groups) {
      return [];
    }
    const cachedGroupSuggestions = groupSuggestionCache.current[value];
    if (cachedGroupSuggestions) {
      return cachedGroupSuggestions;
    }

    const groupsUrl = `/api/v1/groups/search.json?q=${value}`;
    const groupSuggestions = await customFetch(groupsUrl)
      .then(response => response.json())
      .then(json => json.objects);
    groupSuggestionCache.current = {
      ...groupSuggestionCache.current,
      [value]: groupSuggestions
    };
    return groupSuggestions;
  }
  async function fetchUsersSuggestions(value) {
    if (!users) {
      return [];
    }
    const cachedUserSuggestions = userSuggestionCache.current[value];
    if (cachedUserSuggestions) {
      return cachedUserSuggestions;
    }

    const usersUrl = `/api/v1/users/search.json?q=${value}`;
    const userSuggestions = await customFetch(usersUrl)
      .then(response => response.json())
      .then(json => json.objects);
    userSuggestionCache.current = {
      ...userSuggestionCache.current,
      [value]: userSuggestions
    };
    return userSuggestions;
  }

  function updateSuggestions(userSuggestions, groupSuggestions) {
    const typedUserSuggestions = addTypeInfoToSuggestion(
      userSuggestions,
      "user"
    );
    const typedGroupSuggestions = addTypeInfoToSuggestion(
      groupSuggestions,
      "group"
    );
    setSuggestions([...typedUserSuggestions, ...typedGroupSuggestions]);
  }

  function addTypeInfoToSuggestion(suggestions, type) {
    return suggestions.map(suggestion => {
      // Using parseInt because this _${type} thingy causing type to being repeated N - 1 times
      // For each next N suggestion
      suggestion.id = `${parseInt(suggestion.id)}_${type}`;
      suggestion.type = type;
      return suggestion;
    });
  }

  function getSuggestionValue(suggestion) {
    if (suggestion.type === "user") {
      return suggestion.display_name;
    } else if (suggestion.type === "group") {
      return `${suggestion.name}`;
    }
  }

  return {
    fetchSuggestions,
    suggestions,
    getSuggestionValue
  };
}
